import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DetalleConvocatoriaAyudantiasAsignaturasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class DetalleConvocatoriaAyudantiasAsignaturasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getDetalleConvocatoriaAyudantiasAsignaturasPorDetalleConvocatoriaService(codigo: string): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantiasAsignaturas/codigoDetalleConvocatoria/' + codigo);
  }

  getDetalleConvocatoriaAyudantiasAsignaturasService(): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantiasAsignaturas/todos');
  }

  guardarDetalleConvocatoriaAyudantiasAsignaturasService(detalleConvocatoriaAyudantiasAsignaturasDTO: DetalleConvocatoriaAyudantiasAsignaturasDTO): Observable<BodyResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaAyudantiasAsignaturas', detalleConvocatoriaAyudantiasAsignaturasDTO);
  }

  getDetalleConvocatoriaAyudantiasAsignaturasPorCodigoService(codigo: string): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasAsignaturasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantiasAsignaturas/' + codigo);
  }
}
